var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { CacheInfoService } from "./cache_info.service";
import { ConfirmComponent } from '../../views/modal/confirm.component';
import { HttpClient } from '@angular/common/http';
import { ModalService } from "app/views/modal/base_modal.component";
import { Repeater } from "../../lib/Repeater";
import { TranslateService } from "../../translate/translate.service";
import { StartCacheInfoComponent } from "./start_cache_info.component";
import dictionary from "dict/static.json";
var CacheInfoComponent = /** @class */ (function () {
    function CacheInfoComponent(cacheInfoService, modalService, http, _translate) {
        this.cacheInfoService = cacheInfoService;
        this.modalService = modalService;
        this.http = http;
        this._translate = _translate;
    }
    CacheInfoComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.cacheTaskList = dictionary.cacheTaskList;
                        return [4 /*yield*/, me.setData()];
                    case 1:
                        _a.sent();
                        this.repeater = new Repeater(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, me.setData()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }, 2000);
                        this.repeater.start();
                        return [2 /*return*/];
                }
            });
        });
    };
    CacheInfoComponent.prototype.setData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, processList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cacheInfoService.getList().toPromise()];
                    case 1:
                        data = _a.sent();
                        this.pause = data.pause;
                        processList = data.processList;
                        this.list = Object.keys(processList).map(function (key) { return processList[key]; });
                        return [2 /*return*/];
                }
            });
        });
    };
    CacheInfoComponent.prototype.killProcess = function (pid, main) {
        var me = this;
        var r = this.modalService.open(ConfirmComponent, {
            title: me._translate.instant('adminstat.support.cache_info.cache rebuild'),
            message: me._translate.instant('adminstat.support.cache_info.want kill process')
        });
        r.result.then(function (isConfirmed) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(me.list.length > 0 && isConfirmed === true)) return [3 /*break*/, 2];
                            return [4 /*yield*/, me.cacheInfoService.killPid(pid, main).toPromise()];
                        case 1:
                            data = _a.sent();
                            if (data[1] === 1)
                                me.list = [];
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        });
    };
    CacheInfoComponent.prototype.pauseRebuilding = function () {
        var me = this;
        var r = this.modalService.open(ConfirmComponent, {
            title: me._translate.instant('adminstat.support.cache_info.pause process'),
            message: me._translate.instant('adminstat.support.cache_info.want pause rebuild')
        });
        r.result.then(function (isConfirmed) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!isConfirmed) return [3 /*break*/, 2];
                            return [4 /*yield*/, me.cacheInfoService.stopAndPauseRebuilding().toPromise()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        });
    };
    CacheInfoComponent.prototype.resumeRebuilding = function () {
        var me = this;
        var r = this.modalService.open(ConfirmComponent, {
            title: me._translate.instant('adminstat.support.cache_info.resume process'),
            message: me._translate.instant('adminstat.support.cache_info.want resume rebuild')
        });
        r.result.then(function (isConfirmed) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!isConfirmed) return [3 /*break*/, 2];
                            return [4 /*yield*/, me.cacheInfoService.resumeRebuilding().toPromise()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        });
    };
    CacheInfoComponent.prototype.startRebuilding = function () {
        var me = this;
        this.modalService.open(StartCacheInfoComponent, {
            title: me._translate.instant('adminstat.support.cache_info.cache rebuild'),
            cacheTaskList: me.cacheTaskList
        }, { size: 'hg' });
    };
    // startProcess() {
    //    this.dialogService.addDialog(ConfirmComponent, {
    //     title: 'Перестроение кеша',
    //     html: '<ul><li>1</li><li>2</li></ul>'})
    //     .subscribe((isConfirmed)=>{
    //       if (isConfirmed) {
    //         console.log('kill button', pid, main);
    //
    //         this.cacheInfoService.killPid(pid, main).subscribe((data: any) => {
    //           console.log('data', data);
    //         })
    //       }
    //     });
    // }
    CacheInfoComponent.prototype.openModalWithComponent = function () {
        //   this.bsModalRef = this.modalService.show(ModalContentComponent);
        //   this.bsModalRef.content.title = 'Запуск нового процесса перестроения';
        //   this.bsModalRef.content.list = this.cacheTaskList;
    };
    CacheInfoComponent.prototype.ngOnDestroy = function () {
        this.repeater.stop();
    };
    return CacheInfoComponent;
}());
export { CacheInfoComponent };
